import { useCompanyActiveSystems } from './useCompanyActiveSystems';

/**
 * Hook para verificar acesso às funcionalidades GPS do FleetONE
 * GPS agora é parte integrada do FleetONE, não mais um sistema separado
 */
export function useFleetGpsAccess(companyId?: string) {
  const { data: activeSystems, isLoading } = useCompanyActiveSystems(companyId);
  
  const fleetSystem = activeSystems?.find(s => s.code === 'fleet');
  const hasAccess = !!fleetSystem;
  
  return {
    hasAccess,
    isLoading,
    reason: hasAccess ? null : 'Ative o FleetONE para acessar funcionalidades GPS'
  };
}
